import React              from "react";
import {inject, observer} from "mobx-react";
import {toJS}             from "mobx";


//core components
import GridContainer from "../../components/Grid/GridContainer";
import ItemGrid      from "../../components/Grid/ItemGrid";
import IconCard      from "../../components/Cards/IconCard";
import Button        from "../../components/CustomButtons/Button";
import SweetAlert    from "react-bootstrap-sweetalert";

// material-ui icons
import InsertDriveFile  from '@material-ui/icons/InsertDriveFile';
import CircularProgress from "material-ui/Progress/CircularProgress";
import pink             from "material-ui/colors/pink";

// styling
import closeAndSendStyle from "../../assets/jss/material-dashboard-pro-react/layouts/closeAndSend";
import withStyles        from "material-ui/styles/withStyles";
import Cookies from "universal-cookie";

const cookies = new Cookies();


@inject('store')
@observer
class CloseAndSend extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sessioneScattiChiuso: false,
            datiInviatiAiReferenti: false,
            showAlert: false,
            setAlert: null,
            landing_page_status: 1,

        };
        this.store = this.props.store.appState;
    }

    componentWillMount() {
        const self = this;
        const landing_page_status = cookies.get('landing_page_status');
        self.setState({landing_page_status: parseInt(landing_page_status, 10)});

    }

    componentDidMount() {
    }


    handleCloseSession = () => {
        this.setState({showAlert: true});
    }


    handleSendDataToReferents = () => {
        const self = this;
        const DEFAULT_TEXT = toJS(this.store.DEFAULT_TEXT)
        //   localStorage.removeItem('session_closed');

        let params = {
            project_id: self.store.project_id,
            hello: DEFAULT_TEXT.hello,
            referente: DEFAULT_TEXT.referente,
            text_email_1: DEFAULT_TEXT.text_email_1,
            thank: DEFAULT_TEXT.thank,
            we_are: DEFAULT_TEXT.we_are

        };
        self.store.sendDataToReferents(params,function (res) {
            
            if (res){
                self.setState({
                    datiInviatiAiReferenti: true
                })
            } else {
                // console.log('error during send data to referents');
            }
        });

        // // just for test It will be removed when the response from API comes
        // self.setState({
        //     datiInviatiAiReferenti: true
        // })
    }


    closeSession = () => {
        const self = this;

        self.store.change_project_status({idProject: self.store.project_id, stato: 0}, function (result) {
            
            if (result) {
                // localStorage.setItem('session_closed', 'true');

                cookies.set('landing_page_status', 0, {});
                self.setState({landing_page_status: 0});
                self.hideAlert();

            } else {
                // console.log('error during update landing page status');
            }
        });
    }

    hideAlert = () => {
        this.setState({showAlert: false,datiInviatiAiReferenti:false});
    }


    render() {
        // const session_closed = localStorage.getItem('session_closed');
        const {classes} = this.props;
        const {datiInviatiAiReferenti, showAlert, landing_page_status} = this.state;
        const DEFAULT_TEXT = toJS(this.store.DEFAULT_TEXT);

        return (
            <div>
                <GridContainer justify={"center"}>
                    <ItemGrid xs={12} sm={12} md={12}>
                        <ItemGrid xs={12} sm={12} md={12}>
                            <IconCard
                                icon={InsertDriveFile}
                                iconColor="rose"
                                title={DEFAULT_TEXT.sb_close_and_send}
                                content={
                                    <div>
                                        {
                                            !this.state.loading ?
                                                <div style={{marginTop: '40px'}}>
                                                    <div className={classes.buttonsContainer}>
                                                        <div>
                                                            <p className={classes.operation}>
                                                                {DEFAULT_TEXT.ss_close_shoot_session}:
                                                            </p>
                                                        </div>
                                                        <div>
                                                            <Button
                                                                disabled={parseInt(landing_page_status, 10) === 0}
                                                                customClass={classes.closeBtn}
                                                                round
                                                                color={parseInt(landing_page_status, 10) === 0 ? 'primary' : 'rose'}
                                                                onClick={this.handleCloseSession}>
                                                                {DEFAULT_TEXT.btn_close.toUpperCase()}
                                                            </Button>
                                                        </div>
                                                    </div>

                                                    <div className={classes.buttonsContainer}>
                                                        <div>
                                                            <p className={classes.operation}>
                                                                {DEFAULT_TEXT.ss_send_data_label}:
                                                            </p>
                                                        </div>
                                                        <div>
                                                            <Button
                                                                customClass={classes.sendBtn}
                                                                round
                                                                color={datiInviatiAiReferenti ? 'primary' : 'rose'}
                                                                onClick={this.handleSendDataToReferents}>
                                                                {DEFAULT_TEXT.btn_send.toUpperCase()}
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                <div style={this.state.loading ? {
                                                    display: "flex",
                                                    justifyContent: "center"
                                                } : null}>
                                                    <CircularProgress className={classes.progress} style={{color: pink[500]}}/>
                                                </div>
                                        }
                                    </div>
                                }
                            />
                        </ItemGrid>

                        {
                            showAlert
                                ?
                                <SweetAlert
                                    warning
                                    style={{display: "block", marginLeft: '-188px', marginRop: '-182px'}}
                                    title=""
                                    onConfirm={this.closeSession}
                                    onCancel={this.hideAlert}
                                    confirmBtnCssClass={classes.button + " " + classes.success}
                                    cancelBtnCssClass={classes.button + " " + classes.danger}
                                    cancelBtnStyle={{backgroundColor: '#e52d27'}}
                                    confirmBtnText={DEFAULT_TEXT.btn_confirm.toUpperCase()}
                                    cancelBtnText={DEFAULT_TEXT.btn_cancel.toUpperCase()}
                                    showCancel
                                >
                                    {DEFAULT_TEXT.ss_alert_msg}
                                </SweetAlert>
                                : null
                        }

                        {
                            datiInviatiAiReferenti ?
                                <div>
                                    <GridContainer justify={"center"}>
                                        <ItemGrid xs={12} sm={6}>
                                            <SweetAlert
                                                confirmBtnText='Ok'
                                                success
                                                confirmBtnStyle={{background: 'green'}}
                                                title={'Dati inviati corretamente'}
                                                onConfirm={this.hideAlert}
                                                confirmBtnCssClass={this.props.classes.button + " " + this.props.classes.warning}>
                                            </SweetAlert>
                                        </ItemGrid>
                                    </GridContainer>
                                </div>
                                :
                                null
                        }
                    </ItemGrid>
                </GridContainer>
            </div>
        )
    }
}

export default withStyles(closeAndSendStyle)(CloseAndSend);



// WEBPACK FOOTER //
// ./src/views/GestioneScatti/CloseAndSend.jsx